import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../components/Login.vue"),
  },
  {
    path: "/",
    name: "Home",
    redirect: "/order/list",
    component: () => import("../views/Home"),
    children: [
      {
        path: "/order/new",
        component: () => import("../components/order/OrderNew.vue"),
      },
      {
        path: "/order/sub",
        component: () => import("../components/order/OrderSubmit.vue"),
      },
      {
        path: "/order/offer",
        component: () => import("../components/order/OrderOffer.vue"),
      },
      {
        path: "/order/audit",
        component: () => import("../components/order/OrderAudit.vue"),
      },
      {
        path: "/order/edit",
        component: () => import("../components/order/OrderEdit.vue"),
      },
      {
        path: "/order/info",
        component: () => import("../components/order/OrderInfo.vue"),
      },
      {
        path: "/order/affirm",
        component: () => import("../components/order/OrderAffirm.vue"),
      },
      {
        path: "/order/list",
        component: () => import("../components/order/OrderList.vue"),
      },
      {
        path: "/order/cancel-list",
        component: () => import("../components/order/CancelOrder.vue"),
      },
      {
        path: "/order/modify-record",
        component: () => import("../components/order/OrderModifyRecord.vue"),
      },
      {
        path: "/order/cancel",
        component: () => import("../components/order/OrderCancel.vue"),
      },
      /* {
                path: '/order/new-after-sale',
                component: () =>
                    import ('../components/order/OrderNewAfterSale.vue')
            }, */
      /* {
                path: '/order/other-cost',
                component: () =>
                    import ('../components/order/OrderOtherCost.vue')
            }, */
      {
        path: "/order/parts-list",
        component: () => import("../components/order/PartsList.vue"),
      },
      {
        path: "/order/push-list",
        component: () => import("../components/order/PushList.vue"),
      },
      {
        path: "/order/modify-list",
        component: () => import("../components/order/ModifyList.vue"),
      },
      {
        path: "/order/receive-list",
        component: () => import("../components/order/ReceiveList.vue"),
      },
      {
        path: "/order/print",
        component: () => import("../components/order/OrderPrint.vue"),
      },
      {
        path: "/production/add-tail",
        component: () => import("../components/production/AddTail.vue"),
      },
      {
        path: "/production/process-mgt",
        component: () => import("../components/production/ProcessMgt.vue"),
      },
      {
        path: "/production/process-modif",
        component: () => import("../components/production/ProcessModif.vue"),
      },
      {
        path: "/production/warehousing-mgt",
        component: () => import("../components/production/WarehousingMgt.vue"),
      },
      {
        path: "/production/new-process-tail",
        component: () =>
          import("../components/production/NewProcessOrTail.vue"),
      },
      {
        path: "/production/process-tail",
        component: () => import("../components/production/ProcessTail.vue"),
      },
      {
        path: "/production/check-code",
        component: () => import("../components/production/CheckCode.vue"),
      },
      {
        path: "/production/check-seq",
        component: () => import("../components/production/CheckSeq.vue"),
      },
      {
        path: "/production/pack-code",
        component: () => import("../components/production/PackCode.vue"),
      },
      {
        path: "/production/pack-seq",
        component: () => import("../components/production/PackSeq.vue"),
      },
      {
        path: "/production/woodenbox-code",
        component: () => import("../components/production/WoodenBoxCode.vue"),
      },
      {
        path: "/production/woodenbox-seq",
        component: () => import("../components/production/WoodenBoxSeq.vue"),
      },
      {
        path: "/product/finished-product-detail",
        component: () =>
          import("../components/product/FinishedProductDetail.vue"),
      },
      {
        path: "/product/outbound-detail",
        component: () => import("../components/product/OutboundDetail.vue"),
      },
      {
        path: "/epiboly/transport",
        component: () => import("../components/epiboly/TransportEpiboly.vue"),
      },
      {
        path: "/epiboly/new-transport",
        component: () =>
          import("../components/epiboly/NewTransportEpiboly.vue"),
      },
      {
        path: "/epiboly/transport-list",
        component: () => import("../components/epiboly/TransportList.vue"),
      },
      {
        path: "/epiboly/edit-transport",
        component: () =>
          import("../components/epiboly/EditTransportEpiboly.vue"),
      },
      {
        path: "/epiboly/other-cost-list",
        component: () => import("../components/epiboly/OtherCostList.vue"),
      },
      {
        path: "/epiboly/other-cost",
        component: () => import("../components/epiboly/OtherCost.vue"),
      },
      {
        path: "/finance/processing-payment-settlement",
        component: () =>
          import("../components/finance/ProcessingPaymentSettlement.vue"),
      },
      {
        path: "/finance/audit-receivable-amount",
        component: () =>
          import("../components/finance/AuditReceivableAmount.vue"),
      },
      {
        path: "/finance/settlement-center",
        component: () => import("../components/finance/SettlementCenter.vue"),
      },
      {
        path: "/finance/charge-payable",
        component: () => import("../components/finance/ChargePayable.vue"),
      },
      {
        path: "/finance/amount-in-arear",
        component: () => import("../components/finance/AmountInArear.vue"),
      },
      {
        path: "/finance/earning-detail",
        component: () => import("../components/finance/EarningDetail.vue"),
      },
      {
        path: "/finance/disbursement-detail",
        component: () => import("../components/finance/DisbursementDetail.vue"),
      },
      {
        path: "/finance/earning-disbursement-detail",
        component: () =>
          import("../components/finance/EarningDisbursementDetail.vue"),
      },
      {
        path: "/customer/agency",
        component: () => import("../components/customer/AgencyInfo.vue"),
      },
      {
        path: "/customer/customer",
        component: () => import("../components/customer/CustomerInfo.vue"),
      },
      {
        path: "/customer/logistics",
        component: () => import("../components/customer/LogisticsCarrier.vue"),
      },
      {
        path: "/customer/push",
        component: () => import("../components/customer/PushCustomer.vue"),
      },
      {
        path: "/system/employee-mgt",
        component: () => import("../components/system/EmployeeMgt.vue"),
      },
      {
        path: "/system/add-user",
        component: () => import("../components/system/AddUser.vue"),
      },
      {
        path: "/system/change-password",
        component: () => import("../components/system/ChangePassword.vue"),
      },
      {
        path: "/sorder/task",
        component: () => import("../components/sorder/SOrderTask.vue"),
      },
      {
        path: "/sorder/sub",
        component: () => import("../components/sorder/SOrderSubmit.vue"),
      },
      {
        path: "/sorder/offer",
        component: () => import("../components/sorder/SOrderOffer.vue"),
      },
      {
        path: "/sorder/audit",
        component: () => import("../components/sorder/SOrderAudit.vue"),
      },
      {
        path: "/sorder/edit",
        component: () => import("../components/sorder/SOrderEdit.vue"),
      },
      {
        path: "/sorder/info",
        component: () => import("../components/sorder/SOrderInfo.vue"),
      },
      {
        path: "/sorder/affirm",
        component: () => import("../components/sorder/SOrderAffirm.vue"),
      },
      {
        path: "/sorder/list",
        component: () => import("../components/sorder/SOrderList.vue"),
      },
      {
        path: "/sorder/tail-list",
        component: () => import("../components/sorder/SOrderTailList.vue"),
      },
      {
        path: "/sorder/modify-record",
        component: () => import("../components/sorder/SOrderModifyRecord.vue"),
      },
      {
        path: "/sorder/push-list",
        component: () => import("../components/sorder/SPushList.vue"),
      },
      {
        path: "/sorder/modify-list",
        component: () => import("../components/sorder/SModifyList.vue"),
      },
      {
        path: "/sorder/receive-list",
        component: () => import("../components/sorder/SReceiveList.vue"),
      },
      {
        path: "/sorder/process-mgt",
        component: () => import("../components/sorder/SProcessMgt.vue"),
      },
      {
        path: "/sorder/transport",
        component: () => import("../components/sorder/STransportEpiboly.vue"),
      },
      {
        path: "/sorder/transport-list",
        component: () => import("../components/sorder/STransportList.vue"),
      },
      {
        path: "/sorder/new",
        component: () => import("../components/sorder/SOrderNew.vue"),
      },
      {
        path: "/sorder/new-transport",
        component: () =>
          import("../components/sorder/SNewTransportEpiboly.vue"),
      },
      {
        path: "/sorder/edit-transport",
        component: () =>
          import("../components/sorder/SEditTransportEpiboly.vue"),
      },
      {
        path: "/sorder/cancel",
        component: () => import("../components/sorder/SOrderCancel.vue"),
      },
      {
        path: "/sorder/cancel-list",
        component: () => import("../components/sorder/SCancelOrder.vue"),
      },
      {
        path: "/decoration/new-modify",
        component: () => import("../components/decoration/NewAndModify.vue"),
      },
      {
        path: "/decoration/sub",
        component: () => import("../components/decoration/Sub.vue"),
      },
      {
        path: "/decoration/audit",
        component: () => import("../components/decoration/Audit.vue"),
      },
      {
        path: "/decoration/affirm",
        component: () => import("../components/decoration/Affirm.vue"),
      },
      {
        path: "/decoration/list",
        component: () => import("../components/decoration/List.vue"),
      },
      {
        path: "/decoration/cancel-list",
        component: () => import("../components/decoration/CancelList.vue"),
      },
      {
        path: "/decoration/cancel",
        component: () => import("../components/decoration/Cancel.vue"),
      },
      // 库存菜单区域开始
      {
        path: "/inventory/list",
        component: () => import("../components/inventory/List.vue"),
      },
      {
        path: "/inventory/new",
        component: () => import("../components/inventory/New.vue"),
      },
      {
        path: "/inventory/Edit",
        component: () => import("../components/inventory/Edit.vue"),
      },
      {
        path: "/inventory/Info",
        component: () => import("../components/inventory/Info.vue"),
      },
      {
        path: "/inventory/end",
        component: () => import("../components/inventory/EndList.vue"),
      },
      {
        path: "/inventory/cancel-list",
        component: () => import("../components/inventory/CancelList.vue"),
      },
      // @yaotutu更改,增加标准库存列表模块
      {
        path: "/inventory/standard_list",
        component: () => import("../components/inventory/StandardList.vue"),
      },
      {
        path: "/inventory/standard_new",
        component: () => import("../components/inventory/StandardNew.vue"),
      },
      {
        path: "/inventory/standard_edit",
        component: () => import("../components/inventory/StandardEdit.vue"),
      },
      {
        path: "/inventory/standard_info",
        component: () => import("../components/inventory/StandardInfo.vue"),
      },
      {
        path: "/inventory/standard_end",
        component: () => import("../components/inventory/StandardEndList.vue"),
      },
      {
        path: "/inventory/standard_cancel_list",
        component: () =>
          import("../components/inventory/StandardCancelList.vue"),
      },

      //   @yaotutu标准订单修改结束

      // 库存菜单区域结束
      {
        path: "/salary/piece-work-wage",
        component: () => import("../components/salary/PieceWorkWage.vue"),
      },

      {
        path: "/sorder/accept",
        component: () => import("../components/sorder/AcceptAfterSales.vue"),
      },
      {
        path: "/sorder/split",
        component: () => import("../components/sorder/SplitAfterSales.vue"),
      },
      {
        path: "/sorder/print",
        component: () => import("../components/sorder/PrintAfterSales.vue"),
      },
      {
        path: "/sorder/print-completed",
        component: () =>
          import("../components/sorder/PrintCompletedAfterSales.vue"),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
  },
];

const router = new VueRouter({
  routes,
});

//路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === "/login") return next();
  const tokenStr = window.localStorage.getItem("token");
  if (!tokenStr) return next("/login");
  next();
});
export default router;
